// src/analytics.js
import ReactGA from "react-ga4";

const measurementId = "G-GM2H2GH644"; // เปลี่ยนเป็น GA4 ID ของคุณ

export const initGA = () => {
  ReactGA.initialize(measurementId);
};

export const trackPage = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
